module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color3.d68150a2.gif";